import React, { Component } from 'react';
import { Card, Button, ListGroup } from 'react-bootstrap';

export class Primary extends Component {
    render() {
      return <div>
          <h3>Primary</h3>
          <br />
          <Card>
                <Card.Body>
                    <Card.Title>
                    Class Sunday @ 1:10pm - 2:00pm
                    </Card.Title>
                    <h4>
                        Meeting every Sunday.
                    </h4>             
                </Card.Body>              
          </Card>
          <Card>
                <Card.Body>
                    <Card.Title>
                        Resources
                    </Card.Title>
                    <ListGroup>
                        <ListGroupLinkItem link="https://abn.churchofjesuschrist.org/study/manual/come-follow-me-for-primary-old-testament-2022/01?lang=eng" text="Come Follow Me for Children"></ListGroupLinkItem>
                    </ListGroup>
                    <ListGroup>
                        <ListGroupLinkItem link="https://www.youtube.com/watch?v=-fDKdtZGCJM" text="Choose to Serve the Lord by Blake Gillete and Annie Killian"></ListGroupLinkItem>
                        <ListGroup.Item>This is a video of a new song our primary kids are learning this year (The song is not in the primary songbook). It is a beautiful song that mentions lessons we can learn from some of the many women and men in the Old Testament, which we are studying this year in the Come, Follow Me program.</ListGroup.Item>
                    </ListGroup>         
                </Card.Body>              
          </Card>
    </div>;
    }
  }

  class ListGroupLinkItem extends Component {
      render() {
      return <ListGroup.Item>
          <a href={this.props.link}>{this.props.text}</a>
          </ListGroup.Item>
      }
  }

  export default Primary;